import { render, staticRenderFns } from "./redirecting.vue?vue&type=template&id=910d1e66&scoped=true&"
import script from "./redirecting.vue?vue&type=script&lang=ts&"
export * from "./redirecting.vue?vue&type=script&lang=ts&"
import style0 from "./redirecting.vue?vue&type=style&index=0&id=910d1e66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910d1e66",
  null
  
)

export default component.exports